<template>
    <b-row style="min-height: 681px">
        <b-col sm="12">
            <b-card>
                <b-row class="mt-sm-2">
                    <b-col sm="12">
                        <b-row>
                            <b-col sm="1"></b-col>
                            <b-col sm="10">
                                * 인기검색어 순위를 추가하여 인기검색어 순위 변동을 합니다.(적용된 순위가 기존 순위와 같을 경우 기존 순위를 +1 합니다.)
                            </b-col>
                            <b-col sm="1"></b-col>
                        </b-row>
                        <b-row class="pt-sm-2">
                            <b-col sm="1"></b-col>
                            <b-col sm="1" style="font-weight: 600;">순위</b-col>
                            <b-col sm="3" style="font-weight: 600;">인기검색어(사용자화면용)</b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="1" style="text-align: center;">
                                <span class="card-title wise-card-title">검색어추가</span>
                            </b-col>
                            <b-col sm="1">
                                <b-form-input type="number" v-model="queryPrams.rank" />
                            </b-col>
                            <b-col sm="3">
                                <b-form-input type="text" v-model="queryPrams.key" />
                            </b-col>
                            <b-col sm="1">
                                <b-button variant="outline-primary" v-on:click="fnAddKeyword">추가</b-button>
                            </b-col>
                            <b-col sm="1"></b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>
            <b-card>
                <b-row class="mt-sm-2">
                    <b-col sm="12">
                        <b-row>
                            <b-col>
                                <b-row class="pt-sm-2">
                                    <b-col sm="6" style="text-align: center;"><span class="card-title wise-card-title">사용자 인기검색어 TOP10</span> [현재기준]</b-col>
                                    <b-col sm="6" style="text-align: center;"><span class="card-title wise-card-title">관리자 적용</span></b-col>

                                    <b-col sm="6">
                                        <b-table outlined 
                                            hover 
                                            :fields="fields" 
                                            :items="items"
                                            :busy="items == 0"
                                            :current-page="currentPage"
                                            :per-page="rowPage"
                                            style="min-height: 508px;">
                                            <div slot="table-busy" class="text-center my-2">
                                                <strong>데이터가 없습니다.</strong>
                                            </div>
                                            <template slot="rankE" slot-scope="row">
                                                {{ row.index + 1 }}
                                            </template>
                                        </b-table>
                                    </b-col>

                                    <b-col sm="6">
                                        <table class="table b-table border">
                                            <thead>
                                                <tr>
                                                    <th>순서변경</th>
                                                    <th>순위</th>
                                                    <th>인기검색어</th>
                                                    <th>삭제</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="listLoadingA" class="addTbody">
                                                <tr>
                                                    <td colspan="4"><PulseLoader color="#20a8d8"></PulseLoader></td>
                                                </tr>
                                            </tbody>
                                            <tbody v-else is="draggable" v-model="itemsA" :options="{ handle: '.drag-handle' }" tag="tbody" class="addTbody" @change="handleChangeTable()">
                                                <template v-for="(item, index) in itemsA" v-on:key="item.rank">
                                                    <tr class="addTr">
                                                        <td scope="row" class="drag-handle">&#9776;</td>
                                                        <td>{{ item.rank }}</td>
                                                        <td>{{ item.key }}</td>
                                                        <td>
                                                        <b-button v-if="item.key !== ''" variant="outline-danger" size="sm" style="padding: 0rem 0.5rem;" @click="fnDelKeyword(item)">삭제</b-button>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </b-col>                                    
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import swal from 'sweetalert2'
import draggable from 'vuedraggable'
import PulseLoader from "vue-spinner/src/PulseLoader.vue"

export default {
    name: "searchManageList",
    data() {
        return {
            queryPrams: {
                rank: 1,
                key: "",
            },

            listLoading: false,
            currentPage: 1,
            rowPage: 100,
            pageOptions: [10, 30, 50, 100],
            fields: [
                { rankE: { label: "순위", tdClass: 'searchArea' } },
                { key: { label: "인기검색어", tdClass: 'searchArea' } },
            ],
            items: [],

            listLoadingA: false,
            // fieldsA: [
            //     { rank: { label: "순위", tdClass: 'searchArea' } },
            //     { key: { label: "인기검색어", tdClass: 'searchArea' } },
            //     { del: { label: "삭제", tdClass: 'searchArea' } },
            // ],
            itemsA: [],
        }
    },
    mounted() {
        this.findAddPopularKeywordList();
        this.findNowPopularKeywordList();
    },
    components: {
        draggable,
        PulseLoader,
    },
    methods: {
        findAddPopularKeywordList() {
            this.listLoadingA = true;
            this.$http1
                .get("/search/addPopularityAdmin")
                .then((result) => {
                    const { data } = result;
                    this.itemsA = [];
                    this.itemsA = data;
                    this.listLoadingA = false;
            });
        },
        findNowPopularKeywordList() {
            this.listLoading = true;
            this.$http1
                .get("/search/popularity")
                .then((result) => {
                    const { data } = result;
                    this.items = [];
                    this.items = data;
                    this.listLoading = false;
            });
        },
        fnDelKeyword(item) {
            swal.fire({
                    text: "'" + item.key + "' 삭제 하시겠습니까?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'OK'
                  }).then((swalResult) => {
                    if (swalResult.value) {
                        const param = JSON.stringify(item);
                        this.$http1
                            .post("/search/deleteAddPopularKeyword", param
                                , { headers: { "Content-Type": `application/json`} })
                            .then((result) => {
                                const { data } = result;
                                // console.log('===> ', result);
                                if(data === 'ok'){
                                    swal.fire({
                                        type: 'success',
                                        title: '삭제 완료 하였습니다.',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                    
                                    this.findAddPopularKeywordList();
                                    this.findNowPopularKeywordList();
                                }else{
                                    swal.fire({
                                        type: 'error',
                                        title: '삭제 중 오류가 발생하였습니다.',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                }
                        });
                    }
                })
        },
        fnAddKeyword(){
            const reg = /\s/g;
            this.queryPrams.key = this.queryPrams.key.replace(reg, "");

            if(this.queryPrams.rank < 1 || this.queryPrams.rank > 10) {
                swal.fire({
                    type: 'warning',
                    title: '순위는 1위~10위 사이로 지정해주세요.',
                    showConfirmButton: false,
                    timer: 1500
                })
            }else if(this.queryPrams.key === ''){
                swal.fire({
                    type: 'warning',
                    title: '인기검색어를 입력하여주세요.',
                    showConfirmButton: false,
                    timer: 1500
                })
            }else{
                swal.fire({
                    text: "'" + this.queryPrams.key + "' 추가 하시겠습니까?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'OK'
                  }).then((swalResult) => {
                    if (swalResult.value) {
                      const param = JSON.stringify(this.queryPrams);
                      this.$http1
                      .post("/search/insertAddPopularKeyword", param
                          , { headers: { "Content-Type": `application/json`} })
                      .then((result) => {
                          const { data } = result;
                          // console.log('===> ', result);
                          if(data === 'ok'){
                              swal.fire({
                                  type: 'success',
                                  title: '추가 완료 하였습니다.',
                                  showConfirmButton: false,
                                  timer: 1500
                              })
      
                              this.findAddPopularKeywordList();
                              this.findNowPopularKeywordList();
      
                              this.queryPrams.key = "";
                          }else if(data === 'dup'){
                              swal.fire({
                                  type: 'warning',
                                  title: '해당 인기검색어는 이미 등록되어 있습니다.',
                                  showConfirmButton: false,
                                  timer: 1500
                              })
                          }else{
                              swal.fire({
                                  type: 'error',
                                  title: '추가 중 오류가 발생하였습니다.',
                                  showConfirmButton: false,
                                  timer: 1500
                              })
                          }
                      });
                    }
                })
            }
        },
        handleChangeTable() {
            // 드래그 드랍으로 변경된 데이터(변경된 순서대로 전달됨)
            // console.log('dataChangeTable > ', this.itemsA);
            this.listLoadingA = true;
            const param = JSON.stringify(this.itemsA);
            this.$http1
            .post("/search/changeAddPopularKeyword", param
                , { headers: { "Content-Type": `application/json`} })
            .then((result) => {
                const { data } = result;
                if(data === 'ok'){
                    this.findAddPopularKeywordList();
                    this.findNowPopularKeywordList();
                }else{
                    swal.fire({
                        type: 'error',
                        title: '순서 변경 중 오류가 발생하였습니다.',
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
                this.listLoadingA = false;
            })

        }
    },
}
</script>
<style scoped>
.drag-handle {
    cursor: move;
}

.addTbody {
    height: 475.83px;
}
.addTr:hover {
    background-color: #c5cbcee3;
}

.addTr:hover td {
    background-color: transparent;
    /* background-color: #c5cbcee3; */
}

</style>


// WEBPACK FOOTER //
// src/views/site/search/component/tabs/searchManage/SearchManageList.vue